import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import styles from '../style';
import IllustrationContactSvg from '../../../images/illustration-contact';

interface Props {
  classes?: any;
  theme?;
}
const BlocContact = (props: Props) => {
  const { classes, theme } = props;
  return (
    <div className={classes.blocContact}>
      <div>
        <IllustrationContactSvg
          color1={theme ? theme.palette.secondary.main : ''}
          color2={theme ? theme.palette.secondary.light : ''}
        ></IllustrationContactSvg>
      </div>
      <Typography variant="h4">Une question ?</Typography>
      <p>
        Contactez nous au <a href={'tel:0240356334'}>02 40 35 63 34</a>
        <br />
        ou par mail à <a href="mailto:contact@sagaserviceplus.fr">contact@sagaserviceplus.fr</a>
      </p>
      <p>
        Du lundi au vendredi
        <br />
        De 10h à 12h30 et de 14h à 17h
      </p>
    </div>
  );
};

export default withStyles(styles)(BlocContact);
